import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

// The collapsed details line up with the summary text, so the indent has to clear the
// colour indicator and the chevron in front of it.
const indicatorWidth = "3px";
const detailsToggleSize = 24;

export const useStyles = makeStyles()((muiTheme: Theme) => ({
    scrollContainer: {
        height: 500,
        overflowY: "auto",
        padding: muiTheme.spacing(2),
    },
    centeredBox: {
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    noActivityText: {
        textAlign: "center",
        borderBottom: "none",
        padding: 0,
    },
    deviceSummaryIndicator: {
        width: indicatorWidth,
        flexShrink: 0,
        alignSelf: "stretch",
        borderRadius: "18px",
        marginRight: muiTheme.spacing(4),
    },
    eventItem: {
        display: "flex",
        alignItems: "center",
        padding: muiTheme.spacing(3, 0),
        minHeight: 64,
    },
    detailsToggle: {
        flexShrink: 0,
        width: detailsToggleSize,
        height: detailsToggleSize,
        padding: 0,
        color: muiTheme.palette.text.secondary,
    },
    eventDetails: {
        paddingLeft: `calc(${indicatorWidth} + ${muiTheme.spacing(4)} + ${detailsToggleSize}px + ${muiTheme.spacing(1)})`,
        paddingBottom: muiTheme.spacing(3),
    },
    eventContent: {
        display: "flex",
        flex: 1,
        justifyContent: "space-between",
        alignItems: "center",
    },
    primaryBlock: {
        flex: 1,
        flexDirection: "column",
        marginRight: muiTheme.spacing(2),
    },
    secondaryBlock: {
        flex: "0 0 auto",
        textAlign: "right",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        justifyContent: "flex-start",
    },
    secondaryBlockContent: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        gap: muiTheme.spacing(0.5),
    },
    primaryText: {
        fontWeight: 500,
        color: muiTheme.palette.emteria.text.primary,
        margin: 0,
    },
    secondaryLine: {
        display: "flex",
        alignItems: "center",
        columnGap: muiTheme.spacing(1),
        marginTop: 4,
    },
    secondaryText: {
        fontWeight: 400,
        color: muiTheme.palette.text.secondary,
        margin: 0,
    },
    dateTimeText: {
        fontWeight: 400,
        color: muiTheme.palette.text.secondary,
        margin: "4px 0 0 0",
        textAlign: "right",
        paddingBottom: 5,
    },
}));
